"use strict";

var _classCallCheck = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PointerCalldataBlock = void 0;

var ethUtil = require("ethereumjs-util");

var constants_1 = require("../../utils/constants");

var calldata_block_1 = require("../calldata_block");

var PointerCalldataBlock = /*#__PURE__*/function (_calldata_block_1$Cal) {
  _inherits(PointerCalldataBlock, _calldata_block_1$Cal);

  var _super = _createSuper(PointerCalldataBlock);

  function PointerCalldataBlock(name, signature, parentName, dependency, parent) {
    var _this;

    _classCallCheck(this, PointerCalldataBlock);

    var headerSizeInBytes = PointerCalldataBlock._EMPTY_HEADER_SIZE;
    var bodySizeInBytes = PointerCalldataBlock._DEPENDENT_PAYLOAD_SIZE_IN_BYTES;
    _this = _super.call(this, name, signature, parentName, headerSizeInBytes, bodySizeInBytes);
    _this._parent = parent;
    _this._dependency = dependency;
    _this._aliasFor = undefined;
    return _this;
  }

  _createClass(PointerCalldataBlock, [{
    key: "toBuffer",
    value: function toBuffer() {
      var destinationOffset = this._aliasFor !== undefined ? this._aliasFor.getOffsetInBytes() : this._dependency.getOffsetInBytes();

      var parentOffset = this._parent.getOffsetInBytes();

      var parentHeaderSize = this._parent.getHeaderSizeInBytes();

      var pointer = destinationOffset - (parentOffset + parentHeaderSize);
      var pointerHex = "0x".concat(pointer.toString(constants_1.constants.HEX_BASE));
      var pointerBuf = ethUtil.toBuffer(pointerHex);
      var pointerBufPadded = ethUtil.setLengthLeft(pointerBuf, constants_1.constants.EVM_WORD_WIDTH_IN_BYTES);
      return pointerBufPadded;
    }
  }, {
    key: "getDependency",
    value: function getDependency() {
      return this._dependency;
    }
  }, {
    key: "setAlias",
    value: function setAlias(block) {
      this._aliasFor = block;

      this._setName("".concat(this.getName(), " (alias for ").concat(block.getName(), ")"));
    }
  }, {
    key: "getAlias",
    value: function getAlias() {
      return this._aliasFor;
    }
  }, {
    key: "getRawData",
    value: function getRawData() {
      var dependencyRawData = this._dependency.getRawData();

      var rawDataComponents = [];
      rawDataComponents.push(PointerCalldataBlock.RAW_DATA_START);
      rawDataComponents.push(dependencyRawData);
      rawDataComponents.push(PointerCalldataBlock.RAW_DATA_END);
      var rawData = Buffer.concat(rawDataComponents);
      return rawData;
    }
  }]);

  return PointerCalldataBlock;
}(calldata_block_1.CalldataBlock);

exports.PointerCalldataBlock = PointerCalldataBlock;
PointerCalldataBlock.RAW_DATA_START = Buffer.from('<');
PointerCalldataBlock.RAW_DATA_END = Buffer.from('>');
PointerCalldataBlock._DEPENDENT_PAYLOAD_SIZE_IN_BYTES = 32;
PointerCalldataBlock._EMPTY_HEADER_SIZE = 0;